module.exports = __webpack_public_path__ + "img/documentation.043aa419.svg";